document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wp-block-jims-wp-service-location-index h3').forEach(function (element) {
        element.addEventListener('click', toggleState, false);
    });

    function toggleState(event) {
        const element = event.target.parentNode;
        if (element.classList.contains('expanded')) {
            element.classList.remove('expanded');
        }
        else {
            element.classList.add('expanded');
        }
    }
});
